import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import type { FranchiseMini } from '@/Interfaces/Data';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';

const GET_MUNICIPIOS = 'GET_MUNICIPIOS';

const getMunicipiosOnline = () => {
  return apiClientOld
    .get<FranchiseMini[]>('municipios/by-manager')
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

export const useGetMunicipios = (
  options: Omit<
    UseQueryOptions<FranchiseMini[], unknown, FranchiseMini[], string[]>,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_MUNICIPIOS],
    queryFn: () => getMunicipiosOnline(),
    staleTime: Infinity,
    ...options,
  });
};
